var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getSpaceEmbedCode = ({ token, height, width, showListingDetails, showRoomsMenu }) => {
    const spaceUrl = getSpaceUrl({
        token,
        showListingDetails: Boolean(showListingDetails).toString(),
        showRoomsMenu: Boolean(showRoomsMenu).toString(),
    });
    return `<iframe width="${width}" height="${height}" src="${spaceUrl}" frameborder="0" allowfullscreen></iframe>`;
};
export function getSpaceUrl(searchConfig) {
    const spaceUrl = new URL("viewer", process.env.PEEK_APP_VIRTUAL_TOUR_URL);
    spaceUrl.search = new URLSearchParams(searchConfig).toString();
    return spaceUrl;
}
export function copyToClipboard(content) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(content);
        }
        catch (_a) {
            console.log("Error coping content to clipboard");
        }
    });
}
export function camelCaseToReadableCapitalized(name) {
    if (!name)
        return "";
    return name.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
        return str.toUpperCase();
    });
}
